import React, { useState, useEffect, useLayoutEffect } from 'react';
import { connect } from 'react-redux';
import {
    setSelectedSubscribers,
    setCurrentStep,
    updateSubscribersList,
    setMessageData,
    updatePricePlan,
} from '../personalPricePlanBlockSlice';
import { TAB_ENUM } from '../../../Page/SelfCarePage/Constant';
import CheckBox from '../../../Shared/CheckBox/Checkbox';
import { isNullOrEmpty, insertAt, buildUrlAndNavigate } from 'app/utilities/StringHelpers/StringHelpers';
import errorIcon from '../icons/error.svg';
import DOMPurify from 'dompurify';
import BtnNextStep from '../BtnNextStep';
import PriceArea from './PriceArea';
import { DisplayNameOrNumber, PersonalPricePlanStep, subscriberError, messageData, selectSomeSubscibersThereInFamilyPlan } from '../constant';
import { getCurrentCellularPricePlan } from '../../../Block/ChangePricePlanBlock/changePricePlanSlice';
import Skeleton from 'react-loading-skeleton';
import { isMobile } from 'react-device-detect';
import 'react-loading-skeleton/dist/skeleton.css';
import { subscriberErrorType, getDisabledError, getTransitEffectiveDateText, getOtherSubscribersNamesWithSameFamilyPlan } from '../constant';
import Tooltip from 'app/Components/Shared/Tooltip/Tooltip';
import { get } from 'lodash';
import { dwhReportBuilder, reportsDictionary } from '../reportDwh';
import Image from 'app/Components/Shared/Image/image';
const SelectSubscribers = (props) => {
    const { subscribersList, selectedSubscribers, selectedPackage, selectedBan, recommendations, processedSubscriberNo, productsByBan } =
        props.personalPricePlan;
    const { setSelectedSubscribers, setCurrentStep, setMessageData } = props;
    const { pricePlanMetadata } = selectedPackage;
    const parser = new DOMParser();
    const title = parser.parseFromString(selectedPackage?.title, 'text/html').body.textContent;
    const isBRB = pricePlanMetadata?.isBRB;
    const minimumSubscriberForDiscount = pricePlanMetadata?.minimumSubscriberForDiscount;
    const [checkAgreement, setCheckAgreement] = useState(false);
    const [error, setError] = useState(null);
    const [subscribers, setSubscribers] = useState([]);
    const [openedPackageInfo, setOpenedPackageInfo] = useState([]);
    const subsriberError = 'כדי להמשיך יש לבחור לפחות מנוי אחד';
    const agreementError = 'כדי להמשיך יש לאשר את תנאי החבילה';

    useLayoutEffect(() => {
        dwhReportOnLoad();

        if (isNullOrEmpty(selectedPackage)) {
            setCurrentStep(PersonalPricePlanStep.SelectPackage);
        }
        var orderList = getSubscribersOrder();
        setSubscribers(orderList);
    }, [subscribersList]);

    const openOrClosePackageInfo = async (subscriberNo) => {
        let currentSubscriber = subscribersList.find((sub) => sub.subscriberNo === subscriberNo);
        let isOpened = currentSubscriber.openedPackageInfo;
        props.updateSubscribersList({ subscriberNo, field: 'openedPackageInfo', value: !isOpened });

        if (!currentSubscriber.packageInfo) {
            await props.getCurrentCellularPricePlan({ subscriberNo }).then((res) => {
                props.updateSubscribersList({ subscriberNo, field: 'packageInfo', value: res.payload.data.pp_details_desc });
            });
        }
    };

    const dwhReportOnLoad = () => {
        if (subscribersList.length > 1) {
            dwhReportBuilder(reportsDictionary.SELECT_CELL_NUMBER_PAGE_DISPLAY);
        } else {
            dwhReportBuilder(reportsDictionary.CONFIRM_PACKAGE_PAGE_DISPLAY);
        }
    };

    const dwhReportOnButtonClick = () => {
        if (subscribersList.length > 1) {
            dwhReportBuilder(reportsDictionary.SELECT_CELL_NUMBER_BUTTON_CLICK);
        } else {
            dwhReportBuilder(reportsDictionary.CONFIRM_PACKAGE_BUTTON_CLICK);
        }
    };

    const handleToggleSubscriber = (subscriber) => {
        const subscriberNo = subscriber.subscriberNo;
        const isSelected = selectedSubscribers?.includes(subscriberNo);
        const newSelected = isSelected ? selectedSubscribers.filter((id) => id !== subscriberNo) : [...selectedSubscribers, subscriberNo];
        setSelectedSubscribers(newSelected);
        if (error === subsriberError) {
            setError(null);
        }
    };

    const subscriberCheck = () => (selectedSubscribers.length === 0 ? subsriberError : null);
    const agreementCheck = () => (!checkAgreement ? agreementError : null);

    const displayPopup = () => {
        const otherSubscribersNames = getOtherSubscribersNamesWithSameFamilyPlan(subscribersList, selectedSubscribers, true);
        if (isBRB) {
            if (!isNullOrEmpty(otherSubscribersNames)) {
                setMessageData(messageData.SHOULD_SELECT_ALL_SUBSCRIBERS);
                return true;
            }
        } else {
            if (selectSomeSubscibersThereInFamilyPlan(subscribersList, selectedSubscribers)) {
                setMessageData(messageData.POPUP_WARNING_EXIT_PLAN_DISPLAY);
                return true;
            }
        }
        return false;
    };

    const allFamilyMembersSelected = () => {
        return productsByBan.find((b) => b.ban == selectedBan).products.length == selectedSubscribers.length;
    };

    const canContinue = () => {
        var errorMessage = subscriberCheck();
        var canContinue = isNullOrEmpty(errorMessage);
        if (canContinue) {
            if (!displayPopup()) {
                errorMessage = agreementCheck();
                canContinue = isNullOrEmpty(errorMessage);
                if (canContinue) {
                    dwhReportOnButtonClick();
                    props.updatePricePlan();
                }
            }
        }
        if (!isNullOrEmpty(errorMessage)) {
            setError(errorMessage);
        }
    };

    const getSubscribersOrder = () => {
        const disabledSubscribers = subscribersList.filter((s) => !isNullOrEmpty(getDisabledError(s)));
        let activeArr = [];
        let disabledArr = [];

        const processed = subscribersList.find((s) => s.subscriberNo === processedSubscriberNo);
        if (processed) {
            if (!disabledSubscribers.some((s) => s.subscriberNo === processedSubscriberNo)) {
                activeArr.push(processed);
            } else {
                disabledArr.push(processed);
            }
        }

        for (let subscriber of subscribersList) {
            if (subscriber.subscriberNo !== processedSubscriberNo) {
                if (!disabledSubscribers.some((s) => s.subscriberNo === subscriber.subscriberNo)) {
                    activeArr.push(subscriber);
                } else {
                    disabledArr.push(subscriber);
                }
            }
        }

        return [...activeArr, ...disabledArr];
    };

    const SingleSubscriberContent = () => {
        return (
            <div className='single-subscriber-content'>
                <Image src={require('../icons/update.svg')} alt='update' />
                <div className='title'>החבילה שבחרת </div>
                <div className='package-container'>
                    <div className='title selected-package-title'>{title}</div>
                    {pricePlanMetadata?.transitPrice && <div className='transit-text price-text'>דמי מעבר חד פעמיים - ₪{pricePlanMetadata?.transitPrice}</div>}
                    <div className='transit-text effective-date-text'>
                        {getTransitEffectiveDateText(pricePlanMetadata?.isImmediatePlan, pricePlanMetadata?.effectiveDate)}
                    </div>
                </div>
            </div>
        );
    };

    const AgreementContent = () => {
        return (
            <div className='agreement-container'>
                <CheckBox
                    id={'checkAgreement'}
                    checked={checkAgreement}
                    onChange={() => {
                        {
                            if (!checkAgreement && error === agreementError) {
                                setError(null);
                            }
                            setCheckAgreement(!checkAgreement);
                        }
                    }}
                    label={
                        <>
                            <span className='agreement-text'>אישור </span>
                            <span
                                className='link agreement-text'
                                onClick={() => {
                                    buildUrlAndNavigate(selectedPackage.programDetailsLink);
                                }}>
                                {' '}
                                עיקרי פרטי התכנית,
                            </span>{' '}
                            &nbsp;
                            <span
                                className='link agreement-text'
                                onClick={() => {
                                    buildUrlAndNavigate(selectedPackage.connectionAgreementLink);
                                }}>
                                {' '}
                                הסכם ההתקשרות והתנאים הכלליים{' '}
                            </span>
                        </>
                    }
                />
            </div>
        );
    };

    const multipleSubscribersContent = () => {
        const otherSubscribersNames = getOtherSubscribersNamesWithSameFamilyPlan(subscribersList, selectedSubscribers);
        return (
            <>
                <div className='title-container'>
                    <div className='title'>איזה מנויים לצרף לחבילה שבחרת ? </div>
                    <div className='title selected-package-title'>{title}</div>
                    {minimumSubscriberForDiscount > 1 && isBRB && (
                        <div className='discount-text'>לקבלת ההטבה כדאי לבחור {minimumSubscriberForDiscount} מנויים</div>
                    )}
                </div>

                <div className='select-subscriber-content'>
                    {isBRB && !isNullOrEmpty(otherSubscribersNames) && selectedSubscribers.length >= 1 && (
                        <div className='family-plan-container warning'>
                            <Image src={require('../icons/warning.svg')} alt='warning' />
                            <p className='family-plan-title'>
                                &nbsp;בחשבונך קיימת כיום חבילה משפחתית, לעדכון חבילה משפחתית חדשה, יש לצרף אליה גם את&nbsp;
                                {otherSubscribersNames}
                            </p>
                        </div>
                    )}

                    <div className='subscriber-list-container'>
                        {subscribers.map((subscriber) => {
                            const displayName = DisplayNameOrNumber(subscriber);
                            const displayNo = insertAt(subscriber?.subscriberNo, 3, '-');
                            const isSelected = selectedSubscribers?.includes(subscriber.subscriberNo);
                            const caretText = subscriber.openedPackageInfo ? 'סגירה' : '  פרטי חבילה נוכחית ';
                            const disabledError = getDisabledError(subscriber);

                            return (
                                <div className={`subscriber-item ${disabledError ? 'disabled' : ''} ${isSelected ? 'selected' : ''}`} key={displayNo}>
                                    <div className='card-main-content'>
                                        <div className='subscriber-info'>
                                            <div className='right-info'>
                                                <div className={`subscriber-name ${disabledError ? 'disabled' : ''}`}>
                                                    {!disabledError ? (
                                                        <CheckBox
                                                            id={subscriber.subscriberNo}
                                                            checked={isSelected}
                                                            onChange={() => handleToggleSubscriber(subscriber)}
                                                            label={displayName}
                                                        />
                                                    ) : (
                                                        <span>{displayName}</span>
                                                    )}
                                                </div>

                                            </div>
                                            <div className={`left-info ${disabledError ? 'disabled' : ''}`}>
                                                {!isNullOrEmpty(subscriber.productFirstName) && <span className='subscriber-no'>{displayNo}</span>}
                                                {!disabledError && (
                                                    <>
                                                        <span className='package-details-indicator' onClick={() => openOrClosePackageInfo(subscriber.subscriberNo)}>
                                                            {caretText}{' '}
                                                            <Image        
                                                                className={subscriber.openedPackageInfo ? 'open' : 'close'}
                                                                src={require('../icons/caret.svg')}
                                                                alt='arrow'
                                                            />
                                                        </span>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                        {subscriber.openedPackageInfo && (
                                            <div className='package-details'>
                                                {subscriber.packageInfo ? subscriber.packageInfo : <Skeleton count={3} width={'100%'} height={'20%'} />}
                                            </div>
                                        )}
                                    </div>
                                    {disabledError && (
                                        <div className='pp_error_message'>
                                            {disabledError.errorMessage}
                                            <span id={`PP_Tooltip_${displayNo}`}>
                                                <Image src={require('../icons/info.svg')} alt='info' />
                                            </span>
                                            <Tooltip
                                                text={disabledError.errorDescription}
                                                placement={'top'}
                                                cellcomdefault={true}
                                                target={`#PP_Tooltip_${displayNo}`}
                                                display={'inline'}
                                                showCloseButton={true}
                                            />
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>
            </>
        );
    };

    return (
        <div className='select-subscriber-wrapper'>
            {subscribers.length > 1 ? multipleSubscribersContent() : SingleSubscriberContent()}

            {!isMobile && AgreementContent()}
            <div className='summary-footer-container'>
                <PriceArea />
                {isMobile && (
                    <>
                        <svg
                            className='summary-footer-separator'
                            xmlns='http://www.w3.org/2000/svg'
                            width='331'
                            height='1'
                            viewBox='0 0 331 1'
                            fill='none'>
                            <path d='M0 0.5L331 0.500029' stroke='#D9D9DA' />
                        </svg>
                        {AgreementContent()}
                    </>
                )}
                <BtnNextStep text={'עדכון חבילה'} nextStep={PersonalPricePlanStep.SuccessPage} canProceed={canContinue} errorText={error} />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    personalPricePlan: state.personalPricePlan,
});

const mapDispatchToProps = {
    setSelectedSubscribers,
    getCurrentCellularPricePlan,
    setCurrentStep,
    updateSubscribersList,
    setMessageData,
    updatePricePlan,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectSubscribers);
